import { insertEmoji } from '@lyearn/lygo-blocks';
import { EditorView } from '@lyearn/lygo-core';
import { ReactionSelectorProps } from '@/features/reactions/components/ReactionSelector/types';

const getOnSelectReaction: (editorView?: EditorView) => ReactionSelectorProps['onSelect'] =
  (editorView?: EditorView) => (_, emoji) => {
    if (!editorView) {
      return;
    }

    const position = editorView.state.selection.$anchor.pos;
    insertEmoji(editorView, emoji.native, position);
  };

export default getOnSelectReaction;
